import { createResponseTransformer } from "shared/api/createResponseTransformer"
import { serializer } from "shared/api/serializer/serializer"
import { UserPermissionsAPIType } from "shared/types/Project"

export const userPermissionsResponseTransformer = createResponseTransformer(
  json => {
    const deserialized = serializer.deserialize(UserPermissionsAPIType, json)
    if (Array.isArray(deserialized) && deserialized.length === 1) {
      return deserialized[0]
    }
    return deserialized
  }
)

export const allUserPermissionsResponseTransformer = createResponseTransformer(
  json => serializer.deserialize(UserPermissionsAPIType, json)
)
